export const IMAGE_FILE_WIDTHS = [200, 400, 600, 800, 1200, 1600, 2400, 3200, 4800, 6400]; 
export const IMAGE_FILE_HEIGHTS = [100, 200, 300, 400, 600, 800, 1200, 1600, 2400, 3200];
